
/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import useIconSize from './useIconSize';
import {useImpactIconColor} from './useImpactIconColor';

interface NoImpactIconProps {
  size?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) No Impact Icon component for the
 * SC Device Shock Sensor widget.
 */
export const NoImpactIcon = ({size = 180}: NoImpactIconProps) => {
  const {blue, green, paleBlue} = useImpactIconColor();
  const iconSize                = useIconSize(size);
  
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 131 145" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line y1="126.998" x2="130.558" y2="126.998" stroke={green} strokeWidth="3" />
      <rect y="127.769" width="130.558" height="16.7756" fill={paleBlue} />
      <path d="M37.9043 19.3633L92.6535 19.3633C96.5194 19.3633 99.6535 22.4973 99.6535 26.3633V124.581H30.9043L30.9043 26.3633C30.9043 22.4973 34.0383 19.3633 37.9043 19.3633Z" fill={paleBlue} stroke={green} strokeWidth="2" />
      <path d="M53.9507 32.4912H76.6074C80.4734 32.4912 83.6074 35.6252 83.6074 39.4912V112.181H46.9507L46.9507 39.4912C46.9507 35.6252 50.0847 32.4912 53.9507 32.4912Z" fill={dlsColor('white')} stroke={green} strokeWidth="2" />
      <line x1="12.8994" y1="0.857422" x2="12.8994" y2="125.58" stroke={blue} strokeDasharray="1 1" />
      <line x1="117.929" y1="0.857422" x2="117.929" y2="125.58" stroke={blue} strokeDasharray="1 1" />
      <line x1="12.3994" y1="89.3418" x2="116.7" y2="89.3418" stroke={blue} strokeDasharray="1 1" />
      <line x1="12.3994" y1="1.08691" x2="116.7" y2="1.08691" stroke={blue} strokeDasharray="1 1" />
    </svg>
  );
};
